<template>
    <div class="page-for-agent">
        <section class="section-shaped my-0">
            <div class="shape shape-style-1 bg-gradient-success shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="container shape-container">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-8 mt-5">
                        <h2 class="display-3 text-white">Agent's office</h2>
                        <p class="lead text-white">A set of tools for an insurance agent or company employee to enter primary information and receive basic reporting</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="py-6">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img v-lazy="'img/theme/landing-1.png'" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h2>Functionality</h2>
                            <p>The basic set of AIWA tools allows you to get started without additional settings. At the same time, you can easily modify any of them or create a new one.</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div class="badge badge-circle badge-success mr-3">
                                                <i class="ni ni-archive-2"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <h5 class="mb-0">Insurance Products</h5>
                                        </div>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div class="badge badge-circle badge-success mr-3">
                                                <i class="ni ni-caps-small"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <h5 class="mb-0">Printing forms</h5>
                                        </div>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div class="badge badge-circle badge-success mr-3">
                                                <i class="ni ni-chart-bar-32"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <h5 class="mb-0">Reporting</h5>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="py-6">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <img v-lazy="'img/theme/landing-2.png'" class="img-fluid">
                    </div>
                    <div class="col-md-6">
                        <div class="pr-md-5">
                            <h2>Easy interface</h2>
                            <p>Any action is intuitive.
                              <br/>There is no need for special training or training courses to get started as an agent.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="py-6">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">

                        <h2 class="display-3 text-success">Need to automate your agent network?</h2>
                        <p class="lead"></p>
                        <div class="btn-wrapper">
                            <router-link to="/contacts" class="btn btn-success mb-3 mb-sm-0">Contacts us</router-link>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
export default {};
</script>
<style>
</style>
